import { render, staticRenderFns } from "./App.vue?vue&type=template&id=1478209c&scoped=true&"
var script = {}
import style0 from "./App.vue?vue&type=style&index=0&id=1478209c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1478209c",
  null
  
)

export default component.exports